import component from './TakeOffPage.container';

export default component;
